import { render, staticRenderFns } from "./Sachmerkmale.vue?vue&type=template&id=736240db&scoped=true&lang=pug&"
import script from "./Sachmerkmale.vue?vue&type=script&lang=js&"
export * from "./Sachmerkmale.vue?vue&type=script&lang=js&"
import style0 from "./Sachmerkmale.vue?vue&type=style&index=0&id=736240db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736240db",
  null
  
)

export default component.exports